export default __webpack_public_path__ + "static/media/d75ef411c29051e50d67555a2ed9b6161581600702764.6bc33cf6.webp";